import React from 'react'
import { connect } from 'react-redux'
import {
  IntlProvider,
  load,
  registerForIntl,
  LocalizationProvider,
  loadMessages,
} from '@progress/kendo-react-intl'
import { I18nextProvider } from 'react-i18next'
import _ from 'underscore'
import { createBrowserHistory } from 'history'

/* CLDR Data */
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'

import usNumbers from 'cldr-numbers-full/main/en/numbers.json'
import usLocalCurrency from 'cldr-numbers-full/main/en/currencies.json'
import usCaGregorian from 'cldr-dates-full/main/en/ca-gregorian.json'
import usDateFields from 'cldr-dates-full/main/en/dateFields.json'

import bgNumbers from 'cldr-numbers-full/main/bg/numbers.json'
import bgLocalCurrency from 'cldr-numbers-full/main/bg/currencies.json'
import bgCaGregorian from 'cldr-dates-full/main/bg/ca-gregorian.json'
import bgDateFields from 'cldr-dates-full/main/bg/dateFields.json'

import esNumbers from 'cldr-numbers-full/main/es/numbers.json'
import esCurrencies from 'cldr-numbers-full/main/es/currencies.json'
import esCaGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import esDateFields from 'cldr-dates-full/main/es/dateFields.json'
import esTimeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'

import MenuLeft from '../../components/layoutComponents/MenuLeft/menuLeft'
import Header from '../../components/layoutComponents/Header/header'
import Footer from '../../components/layoutComponents/Footer/footer'
import ApiLoader from '../../components/layoutComponents/ApiLoader/apiLoader'
import i18n from '../../i18n'

import esMessages from '../../locales/es/kendoTranslation'
import bgMessages from '../../locales/bg/kendoTranslation'
import enMessages from '../../locales/en/kendoTranslation'
import urlConstant from '../../constants/urlConstant'
import CommonService from '../../services/commonService'
import { getTokenRedirect, tokenRequest } from '../../config/authRedirect'

load(
  likelySubtags,
  currencyData,
  weekData,
  usNumbers,
  usLocalCurrency,
  usCaGregorian,
  usDateFields,
  bgNumbers,
  bgLocalCurrency,
  bgCaGregorian,
  bgDateFields,
  esNumbers,
  esCurrencies,
  esCaGregorian,
  esDateFields,
  esTimeZoneNames,
)

loadMessages(esMessages, 'es')
loadMessages(bgMessages, 'bg')
loadMessages(enMessages, 'en')

const mapStateToProps = ({ apiLoader }) => ({
  apiLoader,
})

const history = createBrowserHistory({ forceRefresh: true })

@connect(({ user }) => ({ user }))
class MainLayout extends React.PureComponent {
  state = {
    locale: localStorage.getItem('i18nextLng') !== null ? localStorage.getItem('i18nextLng') : 'en',
    menuList: [],
  }

  componentDidMount() {
    const { user } = this.props
    getTokenRedirect(tokenRequest).then(response => {
      if (response && response.accessToken) {
        this.getMenuList()
      } else if (user.authenticated) {
        this.getMenuList()
      }
    })
  }

  getMenuList = async () => {
    const currentpath = window.location.pathname
    const getItemTypeURL = urlConstant.Menu.MenuList
    const { apiLoader } = this.props
    apiLoader.isLoading = true
    this.CommonService = new CommonService()
    try {
      const response = await this.CommonService.httpGet(getItemTypeURL, true)
      if (response && response.Value && response.Value.Data) {
        this.setState({
          menuList: response.Value.Data,
        })
        const menuRights = _.contains(_.pluck(response.Value.Data, 'menuLink'), currentpath)
        if (!menuRights) {
          const subMenu = currentpath.split('/')[1]
          const subMenuLink = _.filter(
            _.pluck(response.Value.Data, 'subMenuLink'),
            menu => menu !== null,
          )
          const subMenuRights = _.contains(
            _.flatten(_.map(subMenuLink, menu => menu.split(','))),
            `/${subMenu}`,
          )

          if (!subMenuRights && !window.location.pathname.includes('dashboard')) {
            history.push('/dashboard')
          }
          apiLoader.isLoading = false
        }
      } else {
        console.error('Invalid API response:', response)
      }
    } catch (error) {
      console.error('Error fetching menu list:', error)
    }
  }

  onLocaleChange = event => {
    this.setState({
      locale: event.value,
    })
    i18n.changeLanguage(event.value)
  }

  render() {
    const { children, apiLoader } = this.props
    const { locale, menuList } = this.state

    return (
      <>
        <I18nextProvider i18n={i18n}>
          <LocalizationProvider language={locale}>
            <IntlProvider locale={locale}>
              {apiLoader.isLoading && <ApiLoader />}
              <Header menuList={menuList} />
              <div className="main-container" id="container">
                <div className="overlay" />
                <div className="search-overlay" />
                <MenuLeft menuList={menuList} />
                <div id="content" className="main-content">
                  <div className="layout-px-spacing">{children}</div>
                  <Footer onLocaleChange={this.onLocaleChange} locale={locale} />
                </div>
              </div>
            </IntlProvider>
          </LocalizationProvider>
        </I18nextProvider>
      </>
    )
  }
}

registerForIntl(MainLayout)
export default connect(mapStateToProps)(MainLayout)
